import CircularProgress from '@material-ui/core/CircularProgress';
import { ReactNode } from 'react';
import RedesignModal from '../../shared/components/RedesignModal';
import { useCandidatureModalStyles } from './CandidatureModal.styles';

export type CandidatureModalProps = {
  open: boolean;
  title: string;
  message: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

const CandidatureModal = ({
  open,
  title,
  message,
  confirmLabel = 'Confirmer',
  cancelLabel = 'Refuser',
  loading = false,
  onConfirm,
  onCancel,
}: CandidatureModalProps) => {
  const classes = useCandidatureModalStyles();

  return (
    <RedesignModal
      open={open}
      onClose={onCancel}
      labelledBy="candidature-modal-title"
      paperClassName={classes.modal}
      usePortal={true}>
      <h2 id="candidature-modal-title" className={classes.title}>
        {title}
      </h2>
      <div className={classes.message}>{message}</div>
      {loading && (
        <div className={classes.loadingWrap}>
          <CircularProgress size={32} />
        </div>
      )}
      <div className={classes.actions}>
        <button
          type="button"
          className={classes.cancelButton}
          onClick={onCancel}
          disabled={loading}>
          {cancelLabel}
        </button>
        <button
          type="button"
          className={classes.confirmButton}
          onClick={onConfirm}
          disabled={loading}>
          {confirmLabel}
        </button>
      </div>
    </RedesignModal>
  );
};

export default CandidatureModal;
